export default __webpack_public_path__ + "static/media/joining-team.d0816732.png";